export const SET_IS_DROPDOWN_OPEN = "SET_IS_DROPDOWN_OPEN";
export const ADD_MENU_ITEMS = "ADD_MENU_ITEMS";

export function setIsDropdownOpen(parents, height) {
  return {
    type: SET_IS_DROPDOWN_OPEN,
    payload: {
      parents,
      height
    }
  };
}

export function addMenuItems(menuItems, path) {
  return {
    type: ADD_MENU_ITEMS,
    payload: {
      menuItems,
      path
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/menu/actions.js